import { render, staticRenderFns } from "./pageArticModule.vue?vue&type=template&id=dd5e85e8"
import script from "./pageArticModule.vue?vue&type=script&lang=js"
export * from "./pageArticModule.vue?vue&type=script&lang=js"
import style0 from "./pageArticModule.vue?vue&type=style&index=0&id=dd5e85e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports